// extracted by mini-css-extract-plugin
export var headerCell = "_5j-1";
export var loadingSpinnerContainer = "_5j-4";
export var loadingStateCell = "_5j-5";
export var rowWrapper = "_5j-3";
export var standaloneTable = "_5j-6";
export var table = "_5j-0";
export var white = "_5j-2";